import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiResponse } from '../../data/system/auth';
import { FundData } from '../../data/system/fund';
import { HttpClient } from '@angular/common/http';
import { env } from '../../../app.constant';
import { tap } from 'rxjs/operators';

@Injectable()
export class FundService extends FundData {

  constructor(private http: HttpClient) { super(); }

  getFund(): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.fund_get_list}`;
    return this.http.get<ApiResponse>(host).pipe(
      tap(data => {
        if (Number(data.code) === 2) {
          window.location.href = "#/public/logout";
        }
        console.log(`fund->list->data`, data);
      })
    );
  }

  // getFundSysref(): Observable<ApiResponse> {
  //   const host = `${env.host}${env.endpoint.fund_get_sysref}`;
  //   const options = { withCredentials: true };
  //   const date = new Date();
  //   return this.http.post<ApiResponse>(host, { year: date.getFullYear(), campus: localStorage.getItem('campus') }, options).pipe(
  //     tap(data => console.log(`fund->list->data`, data))
  //   )
  // }

  // getCategory(): Observable<ApiResponse> {
  //   const host = `${env.host}${env.endpoint.fund_get_category}`;
  //   const options = { withCredentials: true };
  //   return this.http.get<ApiResponse>(host, options).pipe(
  //     tap(data => console.log(`category->list->data`, data))
  //   );
  // }

  getTypeAndDescription(fund: string = ""): Observable<ApiResponse> {
    const host = `${env.host}${env.endpoint.fund_get_pap_type_description}`;
    return this.http.post<ApiResponse>(host, { fund: fund }).pipe(
      tap(data => console.log(`papTypeAndDescription->list->data`, data))
    );
  }

  // getBudgetFund(budgetFundParam: GetBudgetFundParameters): Observable<ApiResponse> {
  //   const host = `${env.host}${env.endpoint.fund_get_budget_fund}`;
  //   const options = { withCredentials: true };
  //   return this.http.post<ApiResponse>(host, budgetFundParam, options).pipe(
  //     tap(data => console.log(`budgetFund->list->data`, data))
  //   );
  // }

  // getFUndSourceReference(code: string): Observable<ApiResponse> {
  //   const host = `${env.host}${env.endpoint.fund_get_fund_source_reference.replace("{code}", code)}`;
  //   const options = { withCredentials: true };
  //   return this.http.get<ApiResponse>(host, options);
  // }

}
